import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';
import { EscalationPriority } from '@/services/QA/escalation';

export class EscalateForm {
  public departmentManager: string = '';
  public shiftManager: string = '';
  public reason: string = '';
  public priority: EscalationPriority = EscalationPriority.NORMAL;

  public rules: { [key: string]: FormValidationFunction[] } = {
    escalatedTo: [
      () => (!!this.departmentManager && !!this.departmentManager.length)
        || (!!this.shiftManager && !!this.shiftManager.length)
        || 'You should select "Department Manager" or "Shift Manager"',
    ],
    reason: [
      (v: string) => !!v.length || 'Comment is required',
    ],
    priority: [],
  };
}
